import * as React from 'react';
import { ChronoUnit } from 'js-joda';
import _ from 'lodash';

import { humanizeDurationString, shortEnglishHumanizer } from 'utils/timeUtils';
import Select from '@tock/shared/components/inputs/Select';

/**
 * Generates a range of durations from 15 minutes to 12 hours.
 * This top of this range is arbitrary.
 */
export const durationOptions = _.map(_.range(1, 49), (i) => {
  const minutes = i * 15; // 15 minute increments
  return {
    key: `${minutes}`,
    label: humanizeDurationString(`${minutes}`, ChronoUnit.MINUTES, {}, shortEnglishHumanizer),
    value: `${minutes}`,
  };
});

const SKINNY_CLASS_NAME = 'Select--skinny Select--minimal';

interface Props {
  disabled?: boolean;
  durationMinutesField: ReduxFormField<string>;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  skinny?: boolean;
}

export default class SelectDuration extends React.PureComponent<Props> {
  render() {
    const { disabled, durationMinutesField, onChange, skinny } = this.props;
    return (
      <Select
        disabled={disabled}
        field={durationMinutesField}
        modifierClassName={skinny ? SKINNY_CLASS_NAME : undefined}
        onChange={onChange}
        options={durationOptions}
      />
    );
  }
}
